import { FC } from 'react';

import { useTranslations } from '../hooks/useTranslations.ts';
import { translationKeys } from '../translations/translationKeys.ts';
import { Linkify } from '../utils/textFormatters.tsx';
import ThankYouScreenWrapper, { ThankYouScreenProps } from './ThankYouScreenWrapper.tsx';

const ThankYouScreenMetaTrader: FC<ThankYouScreenProps> = (props) => {
  const { translate } = useTranslations();
  const isLive = props.context !== 'Demo';
  const title = isLive
    ? translate(translationKeys.THANK_YOU_APPLICATION_RECEIVED_TITLE)
    : translate(translationKeys.THANK_YOU_DEMO_READY_TITLE);
  return (
    <ThankYouScreenWrapper {...props} title={title} disableOnMobile>
      <div>
        {isLive && (
          <div className="w-full mb-6">
            <p className="text-base leading-6 text-content-secondary">
              {translate(translationKeys.THANK_YOU_REVIEWING_BODY)}
            </p>
          </div>
        )}
        {isLive && (
          <div className="w-full mb-6">
            <p className="text-base leading-6 text-content-secondary">
              <span className="font-bold">{translate(translationKeys.THANK_YOU_DEMO_READY_HEADING)}</span>
              <br />
              <Linkify>{translate(translationKeys.THANK_YOU_METATRADER_LOGIN_CTA)}</Linkify>
            </p>
          </div>
        )}

        {!isLive && (
          <div className="w-full mb-6">
            <p className="text-base leading-6 text-content-secondary">
              <Linkify>{translate(translationKeys.THANK_YOU_METATRADER_LOGIN_CTA)}</Linkify>
            </p>
          </div>
        )}
      </div>
    </ThankYouScreenWrapper>
  );
};

export default ThankYouScreenMetaTrader;
